import { Checkbox, ListItemText, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { memo, useEffect, useState } from "react";
import List from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import {
  StyledList,
  StyledListItemButton,
  StyledListItemIcon,
  StyledListItemText,
  SubItem
} from "components/Reports/components";
import SubItemCloseIcon from "assets/icons/SubItemCloseIcon";
import SubItemOpenIcon from "assets/icons/SubItemOpenIcon";
import { useSelector } from "react-redux";
import EditIconLight from "assets/icons/EditIconLight";
import TrashIcon from "assets/icons/TrashIcon";
import { appSetModal } from "store/actions/appAction";
import { apiDeleteAccountingType } from "api/accountingTypeApi";
import BasicButton from "components/BasicInputs/BasicButton";
import { Add } from "@mui/icons-material";
import { useAppDispatch, useAppSelector } from "store/store";
const StyledSubItem = styled(SubItem)({
  backgroundColor: "#F0F5FC"
});

const SubListItemText = styled(ListItemText)({
  paddingRight: "10px"
});
const SubListItemTextRight = styled("div")({
  maxWidth: "350px",
  display: "grid",
  width: "100%",
  gridTemplateColumns: "40% 40%",
  justifyContent: "space-evenly"
});
const SubText = styled(Typography)({
  padding: "10px",
  textAlign: "right"
});
const ActionRightSection = styled("div")({
  width: "250px",
  maxHeight: "36px",
  display: "flex",
  justifyContent: "space-between",
  gap: 12
});

const isOpen = (data: accountTypeType, id?: number) => {
  const children = data.childs;
  if (!children) return false;
  try {
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      if (child.id === id) return true;
      if (isOpen(child, id)) return true;
    }
  } catch {
    return false;
  }
};

const ListSubItem = memo(
  ({
    breadcrumbItems,
    data,
    paddingRight,
    parentName,
    parentCode,
    handleChange,
    selected
  }: {
    data: accountTypeType;
    breadcrumbItems: string[];
    paddingRight: number;
    parentName?: string;
    parentCode?: string;
    handleChange?: (
      id: number,
      breadCrumb: string[],
      title?: string,
      accountingCode?: string,
      detail?: string,
      code?: string,
      targetTable?: string,
      parentCode?: string,
      addable?: boolean,
      isCurrency?: boolean
    ) => void;
    selected?: number;
  }) => {
    const { openReports } = useSelector((state: any) => state).appReducer as { openReports: boolean };
    const id = data?.id;
    const [open, setOpen] = useState(openReports || isOpen(data, selected));
    useEffect(() => {
      setOpen(openReports);
    }, [openReports]);

    const childPaddingRight = paddingRight + 20;

    const handleClick = (e: React.MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.tagName !== "INPUT") {
        setOpen(!open);
      }
    };

    const currentBreadCrumb = [...breadcrumbItems, data?.title];

    const handleCheckChange = () => {
      handleChange && handleChange(id, currentBreadCrumb, data?.title, data?.accountingCode, data?.detail, data?.code, data?.target_table, parentCode, data.addable,data.isCurrency);
    };

    if (data.childs && data.childs.length > 0) {
      return (
        <>
          <StyledListItemButton
            disableRipple
            active={open}
            onClick={handleClick}
            paddingRight={childPaddingRight}
          >
            {id && (
              <Checkbox
                checked={id === selected}
                onClick={(ev) => {
                  if (!ev.isDefaultPrevented())
                    handleCheckChange();
                }}
              />
            )}

            <StyledListItemIcon>{open ? <SubItemCloseIcon /> : <SubItemOpenIcon />}</StyledListItemIcon>
            <StyledListItemText>
              <Typography variant="body2">{data?.code && `${data.code} - `}{data.title}</Typography>
            </StyledListItemText>
            <SubListItemTextRight>
              <SubText variant="body2">{data?.cost?.detail || data?.detail}</SubText>
              <SubText variant="body2">{parentName}</SubText>
            </SubListItemTextRight>
          </StyledListItemButton>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {data.childs &&
                data.childs.map((item) => (
                  <ListSubItem
                    key={item.id}
                    breadcrumbItems={[...breadcrumbItems, data?.title]}
                    selected={selected}
                    handleChange={handleChange}
                    parentName={data.title}
                    parentCode={data?.code}
                    paddingRight={childPaddingRight}
                    data={item}
                  />
                ))}
            </List>
          </Collapse>
        </>
      );
    }
    return (
      <SubItem paddingRight={childPaddingRight}>
        {id && (
          <Checkbox
            checked={id === selected}
            onClick={(ev) => {
              if (!ev.isDefaultPrevented())
                handleCheckChange();
            }}
          />
        )}
        <SubListItemText>
          <Typography variant="body2">{data?.code && `${data.code} - `}{data.title}</Typography>
        </SubListItemText>
        <SubListItemTextRight>
          <SubText variant="body2">{data?.cost?.detail || data?.detail}</SubText>
          <SubText variant="body2">{parentName}</SubText>
        </SubListItemTextRight>
      </SubItem>
    );
  }
);

const AccountingTypeList = ({
  data,
  refetchFunction
}: {
  data: accountTypeType;
  refetchFunction: (token: any) => (dispatch: any, getState: any) => void;
}) => {
  const initialPaddingRight = 0;
  const initialBreadcrumbItems = [] as string[];
  const [accountingData, setAccountingData] = useState<{
    accountingCode?: string;
    title?: string;
    detail?: string;
    code?: string;
    targetTable?: string;
    parentCode?: string
    isCurrency?: boolean
  }>();

  const dispatch = useAppDispatch();

  const [selected, setSelected] = useState<number>();
  const [addable, setAddable] = useState<boolean>(false);
  const [breadCrumb, setBreadCrumb] = useState(initialBreadcrumbItems);
  const store = useAppSelector((x) => x);
  const token = store.businessReducer.business.token;

  const handleCheckboxChange = (
    id: number,
    breadCrumb: string[],
    title?: string,
    accountingCode?: string,
    detail?: string,
    code?: string,
    targetTable?: string,
    parentCode?: string,
    addable?: boolean,
    isCurrency?: boolean
  ) => {
    setBreadCrumb(breadCrumb);
    console.log(id,
      breadCrumb,
      title,
      accountingCode,
      detail,
      code,
      targetTable,
      parentCode,
      addable,
      isCurrency)
    setAccountingData({
      title,
      accountingCode,
      detail,
      code,
      targetTable,
      parentCode,
      isCurrency
    });
    const selectedd = selected === id ? undefined : id
    setAddable(addable === true && selectedd != undefined)
    setSelected((selected) => selectedd);
  };

  return (
    <StyledList
      sx={{ width: "100%", bgcolor: "background.paper", marginBottom: "10px", padding: 0 }}
      aria-labelledby="nested-list-subheader"
    >
      <StyledSubItem>
        <SubListItemText>
          <Typography variant="body2">حساب</Typography>
        </SubListItemText>
        <SubListItemTextRight>
          <SubText variant="body2">تفصیل</SubText>
          <SubText variant="body2">گروه حساب</SubText>
        </SubListItemTextRight>
      </StyledSubItem>
      {data.childs && (
        <ListSubItem
          breadcrumbItems={initialBreadcrumbItems}
          selected={selected}
          handleChange={handleCheckboxChange}
          parentName={data.title}
          parentCode={accountingData?.code}
          paddingRight={initialPaddingRight}
          data={data}
        />
      )}
      <SubItem sx={{ justifyContent: "space-between", position: "sticky", bottom: 0, left: 0, zIndex: 5 }} gray>
        <BasicButton
          variant="outlined"
          disabled={!addable}
          onClick={(ev) => {
            ev.preventDefault()
            ev.stopPropagation()
            ev.detail = 99;
            dispatch(
              appSetModal(
                {
                  component: "add-account-type",
                  title: "افزودن حساب جدید",
                  closeButton: true,
                  breadCrumb: breadCrumb,
                  id: selected,
                  parentCode: accountingData?.code,
                  maxWidth: 350
                },
                true
              )
            );
          }
          }
        >
          <Add />
          <span>افزودن حساب</span>
        </BasicButton>
        <ActionRightSection>
          <BasicButton
            onClick={() =>
              dispatch(
                appSetModal(
                  {
                    component: "add-account-type",
                    title: "ویرایش حساب",
                    closeButton: true,
                    breadCrumb: breadCrumb,
                    id: selected,
                    parentCode: accountingData?.parentCode,
                    initialAccountingData: accountingData,
                    maxWidth: 350
                  },
                  true
                )
              )
            }
            disabled={!selected}
            variant="contained"
            startIcon={<EditIconLight />}
          >
            <span>ویرایش</span>
          </BasicButton>
          <BasicButton
            onClick={() => dispatch(apiDeleteAccountingType(selected, token, refetchFunction))}
            disabled={!selected}
            variant="contained"
            color="error"
            startIcon={<TrashIcon />}
          >
            <span>حذف</span>
          </BasicButton>
        </ActionRightSection>
      </SubItem>
    </StyledList>
  );
};

export default AccountingTypeList;
